module.exports = __webpack_public_path__ + "img/_BlueTiger.ff3be842.png";